// Who published a Social Listening mention: the post's author or, for news,
// the outlet. sm.back fills author_name / source_name
// (modules/mentionAuthor.js). A news mention is credited to its outlet;
// Sentione's journalist name, when present, follows it.

// A few scraped posts carry the scraper's placeholder instead of a name.
const isPlaceholder = (name: string) => /^unknown$/i.test(name.trim())

export const getMentionByline = ({
  authorName,
  sourceName,
}: {
  authorName?: string | null
  sourceName?: string | null
}): string | null => {
  const author = authorName && !isPlaceholder(authorName) ? authorName : null
  const name = sourceName || author
  if (!name) return null
  return sourceName && author && author !== sourceName
    ? `${sourceName} · ${author}`
    : name
}
